import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {ServiceConfig} from "../../../model/config/service-config";
import {Capability, CapabilityGroup} from "../../../model/config/capability";

export const serviceConfigSelector = () => createSelector(
  [getUseQueryResultData<ServiceConfig>],
  (data) => {
    return data;
  }
);

export const serviceCapabilitiesSelector = () => createSelector(
  [getUseQueryResultData<Capability[]>],
  (data) => {
    return data ?? [];
  }
);

export const serviceGroupedCapabilitiesSelector = () => createSelector(
  [getUseQueryResultData<CapabilityGroup[]>],
  (data) => {
    return data ?? [];
  }
);
